import { Outlet, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { Box, Flex, FlexItem, Link } from '@gusto/workbench';
import ProgressBar from 'components/progress_bar';
import { isBlank } from 'components/accounting_firm_discovery_survey/utils';
import AccountantFirm from '../../../../images/signupV2/AccountantFirm.svg';
import { usePartnerSignupContext } from './partnersSignupProvider';
import type { SignUpGoalsValues, YesNoValues, PerkGoalsValues } from './types';
import StarGinger from '../../../../images/signupV2/star-ginger.svg';

const Layout = () => {
  const { pathname } = useLocation();
  const { signupGoals, runPayrollForClients, offerAdvisoryServices, perkGoals } =
    usePartnerSignupContext();

  const calculatePercentage = () => {
    const answers: ([SignUpGoalsValues] | YesNoValues | [PerkGoalsValues] | undefined)[] = [
      signupGoals,
      runPayrollForClients,
      offerAdvisoryServices,
      perkGoals,
    ];

    return answers.map(ans => (!isBlank(ans) ? 100 / answers.length : 0)).reduce((a, b) => a + b);
  };

  return (
    <section className="partners-signup-layout">
      <Flex width="100wh" flexDirection="column" flexDirectionMd="row">
        {pathname !== '/form' && (
          <ProgressBar percentage={calculatePercentage()} headerId="#lead-nav" />
        )}
        <Flex
          heightMd="100vh"
          widthLg="50%"
          widthMd="54%"
          flexDirection="column"
          alignItems="center"
          justifyContent="space-between"
          className="get-started-box"
        >
          {pathname === '/form' ? (
            <Box textAlign="center" marginTop="20px" widthLg="60%">
              <h2>Welcome to Gusto for Accountants</h2>
              <p className="layout-subheading">
                Finish creating your account and add your clients. Up to 20% revenue share for your
                firm or discounts for your clients.{' '}
                <Link href="/legal/terms/partners" target="_blank" rel="noopener">
                  Terms apply
                </Link>
                .
              </p>
            </Box>
          ) : (
            <Box
              textAlign="center"
              paddingTop="20px"
              paddingLeft="20px"
              paddingRight="20px"
              className="partners-surface-page"
            >
              <h2>Gusto for Accountants</h2>
              <p className="layout-subheading">
                We offer one intuitive place to manage payroll, benefits, and HR for your clients.
              </p>
              <p className="text-default grey-text">
                Already use Gusto?{' '}
                <Link
                  onClick={() =>
                    GustoAnalytics.track({
                      eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
                      eventName: 'SignInClick',
                      data: {
                        location: 'Partners Signup v2',
                      },
                    })
                  }
                  href="/login"
                >
                  Sign in
                </Link>
              </p>
            </Box>
          )}
          <Box className="add-client-promotion-card-wrapper">
            <Flex className="add-client-promotion-card" alignItems="center" justifyContent="center">
              <FlexItem flexBasis="15%">
                <img src={StarGinger} alt="Star" />
              </FlexItem>
              <FlexItem flexBasis="85%">
                <div className="add-client-promotion-title">
                  Earn $400 for every client you introduce to Gusto Payroll.
                </div>
                <div className="grey-text">
                  Limited time offer.{' '}
                  <a href="https://gusto.com/legal/terms/promotional-terms">Terms</a> apply
                </div>
              </FlexItem>
            </Flex>
          </Box>
          <img
            className={classNames('accounting_firm', {
              accounting_form_small_hide: pathname === '/form',
            })}
            alt="Accounting firm employees"
            src={AccountantFirm}
          />
        </Flex>
        <Flex
          widthLg="50%"
          widthMd="46%"
          alignItems="center"
          justifyContent="center"
          overflow="scroll"
          className="question-box"
        >
          <Outlet />
        </Flex>
      </Flex>
    </section>
  );
};

export default Layout;
